/** @jsxImportSource @emotion/react */
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { TextField } from "./TextField";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import { useRef } from "react";
import { SmallBadge } from "../../SmallBadge";
import { css } from "@emotion/react";
import { StyledText } from "../../../assets/typography/typography";
import { colors } from "../../colors";
import { breakpoints } from "../../breakpoints";

type Props = {
  searchValue: string;
  setSearchValue: (value: string) => void;
  placeholder?: string;
  isDefaultValues?: boolean;
};

const additionalBadgeStyle = css`
  ${breakpoints.tablet} {
    display: none;
  }
`;

const floatingElementStyle = css`
  display: flex;
  align-items: center;
  gap: 6px;
`;

const badgeStyle = css`
  height: 24px;
  min-height: 24px;
  align-items: center;
  justify-content: center;
`;

const searchIconWrapperStyle = css`
  ${badgeStyle}
  display: flex;
`;

const searchIconTextStyle = css`
  display: flex;
`;

export const SearchTextFieldWithKeyboardInteraction = ({
  searchValue,
  setSearchValue,
  placeholder = "Search...",
  isDefaultValues = false,
}: Props) => {
  const inputRef = useRef<HTMLInputElement>(null);
  document.addEventListener("keydown", (e) => {
    const key = e.key;
    const cmdHeld = e.metaKey;
    if (key === "k" && cmdHeld && inputRef.current) {
      inputRef.current.focus();
      e.preventDefault();
    }
  });

  return (
    <TextField
      value={!isDefaultValues ? searchValue : undefined}
      defaultValue={isDefaultValues ? searchValue : undefined}
      innerRef={inputRef}
      placeholder={placeholder}
      floatingElement={
        <div css={floatingElementStyle}>
          <SmallBadge additionalStyles={[badgeStyle, additionalBadgeStyle]}>
            <StyledText
              color={colors.textPrimary}
              className="bodySubtextRegular mb-0"
            >
              ⌘ K
            </StyledText>
          </SmallBadge>
          <div css={searchIconWrapperStyle}>
            <StyledText
              css={searchIconTextStyle}
              color={colors.textPrimary}
              className="bodyTextRegular mb-0"
            >
              <FontAwesomeIcon icon={solid("search")} />
            </StyledText>
          </div>
        </div>
      }
      onChange={(e) => {
        setSearchValue(e.target.value);
      }}
    />
  );
};
